import { Box } from "@mui/material";
import { FiltersDrawer } from ".";
import { DinamicForm } from "../dinamicForm";
import { InputModel } from "../../utils/types";
import { ObjectGeneric, onChange } from "../../utils/types/generals";

type FloatFilterProps = {
    cleanFilter: () => void
    counter: number | null
    right?: number
    top?: number
    input: Record<string, InputModel>
    values: ObjectGeneric
    onChange: onChange
    filter?: boolean
    headerChildren?: JSX.Element
    footerChildren?: JSX.Element
}

export function FloatFilter({ cleanFilter, onChange, counter, right = 0, top = 110, input, values, filter, footerChildren, headerChildren, }: FloatFilterProps) {
    return (
        <FiltersDrawer cleanFilter={cleanFilter} count={counter} right={right} top={top} >
            <Box mb={4}>
                <DinamicForm
                    headerChildren={headerChildren}
                    footerChildren={footerChildren}
                    input={Object.values(input)}
                    values={values}
                    onChange={onChange}
                    filter={!!filter}
                />
            </Box>
        </FiltersDrawer>
    )
}